import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

export interface PreOrderValidDate {
  id: string;
  valid_date: string;
}

// Параметры загрузки дат действия предзаказов ИП
export interface LoadIndividualOffersValidDatesQueryParams {
  ids: string[];
  limit: number;
}

// Ответ на загрузку дат действия предзаказов ИП
export interface LoadIndividualOffersValidDatesQueryResponse {
  items: PreOrderValidDate[];
}

// Даты действия предзаказов ИП. Отдельно от загрузки корзины: у обычных предзаказов valid_date нет
export class LoadIndividualOffersValidDatesQuery
  implements GraphQLQuery<LoadIndividualOffersValidDatesQueryParams>
{
  readonly query: any;

  readonly variables: LoadIndividualOffersValidDatesQueryParams;

  constructor(ids: string[]) {
    this.variables = { ids, limit: ids.length };

    this.query = gql`
      query __LOAD_INDIVIDUAL_OFFERS_VALID_DATES__($ids: [ID], $limit: Int) {
        items: pre_order_list(where: { id: { _in: $ids } }, limit: $limit) {
          id
          valid_date
        }
      }
    `;
  }
}
